// extracted by mini-css-extract-plugin
module.exports = {"input":"AdaptiveInput_input_3qB8Q","ghostWrapper":"AdaptiveInput_ghostWrapper_3TZp6","ghost":"AdaptiveInput_ghost_amSZ_"};